
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import React from "react";
import CreateAttributeList, { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { HeadingIcon } from "../Icons/ComponentIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { UpdateStyleFunction } from "../Stylebuilder";
import { SiteData } from "../Data/SiteData";
import WebDesigner from "../WebDesigner";
import ApplyToGlobalButton from "../Menus/ApplyToGlobalButton";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";




export default class Heading extends WBComponent {

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return[
            new AttributeDefinition("headingType","Heading Type","",AttributeInputType.SelectField,
            [{label:"Heading 1",value:"h1"},{label:"Heading 2",value:"h2"},{label:"Heading 3",value:"h3"},{label:"Heading 4",value:"h4"},])
        ]
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        //check if there is already an h1 on the page and if so set this to h2
        const canvas = document.getElementById("v-canvas");
        if(canvas){
            const headers = canvas.querySelectorAll("h1");

            if(headers.length>1){ //this header should be returned as an h1 so check for greater than 1 instead of 0
                setNodeComponentAttributeValue(thisLayout,"headingType","h2");
            }

        }
    }


    constructor(){
        super();
        this.typename = wBComponentTypeNames.heading;
        this.displayName = "Heading";
        this.dropList = defaultDropList;
        this.contentEditable = true;
        this.editList = [
            attributeTypes.alignContent,
            "headingType",
            ...CreateAttributeList(true,true,true,true,true)
        ];
        this.primaryEditAttributes = [
            "headingType",
            attributeTypes.fontSize,

            attributeTypes.textAlign,
            "textVertical"

        ]

        this.icon = <HeadingIcon/>
        this.defaultGridSize = {width:300,height:50};
    }


    RenderLayout({component,children,screenSize,userContext: siteData,isEditor}:WBRenderProps) {

        let headerType = (component.componentAttributes["headingType"])??"h1";

        let getConent = component.content??"";

        if(getConent.startsWith("<p>")&&getConent.endsWith('</p>')&&getConent.indexOf('<p>',3)<0){ //single p quotes just delete them..


            getConent = getConent.substring(3,getConent.length-4);
        }


        const atts = GetNodeDomAttributes("v-heading max-100",component,screenSize,isEditor);



            switch(headerType){

                case "h2":

                    return <h2 {...atts} suppressContentEditableWarning={true} dangerouslySetInnerHTML={{ __html: getConent??"" }}></h2>
                case "h3":

                    return <h3 {...atts} suppressContentEditableWarning={true} dangerouslySetInnerHTML={{ __html: getConent??"" }}></h3>
                case "h4":

                    return <h4 {...atts}suppressContentEditableWarning={true} dangerouslySetInnerHTML={{ __html: getConent??"" }}></h4>
                default: //h1

                    return <h1 {...atts} suppressContentEditableWarning={true} dangerouslySetInnerHTML={{ __html: getConent??"" }}></h1>


        }

    }

    RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData, webDesigner }: { updateFunc: UpdateStyleFunction; saveFunc: Function; editList: string[]; primaryList: string[]; layoutNode: AttributeCollection | null; screenSize: ScreenSize; showScreenSize?: boolean | undefined; siteData: SiteData; webDesigner: WebDesigner; }): JSX.Element {



        const content = super.RenderMenu({editList,primaryList,layoutNode,screenSize,updateFunc,saveFunc,showScreenSize,siteData});



        if(!layoutNode)
        return content;

            const getCollection = (node: AttributeCollection) => {
              const hdrType = getNodeComponentAttributeValue(
                layoutNode,
                "headingType",
                "h1"
              );

              let collection = siteData.siteStyling.heading1;
              switch (hdrType) {
                case "h2":
                  collection = siteData.siteStyling.heading2;
                  break;
                case "h3":
                  collection = siteData.siteStyling.heading3;
                  break;
                case "h4":
                  collection = siteData.siteStyling.heading4;
                  break;
              }

              return collection;
            };



        return <>
            {content}
            <br></br>
            {screenSize===ScreenSize.Desktop&&
            <ApplyToGlobalButton siteData={siteData} layoutNode={layoutNode} getCollectionFunc={getCollection} />}
        </>

    }



}